module.exports = __webpack_public_path__ + "static/img/index_02_01.d250600.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index_02_01.png
// module id = zDbi
// module chunks = 1